<mat-dialog-content>
	<p>
		<strong i18n="@@delete_popup_SureYouWantToDelete"
			>Are you sure you want to delete?</strong
		>
	</p>
	<p i18n="@@delete_popup_NotAbleToRetrieveData">
		You will not be able to retrieve the data.
	</p>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
	<button
		mat-button
		i18n="@@button_cancel"
		[mat-dialog-close]="false"
		color="accent"
	>
		Cancel
	</button>
	<button
		id="button_delete_confirm_popup"
		mat-flat-button
		i18n="@@button_delete"
		[mat-dialog-close]="true"
		color="warn"
	>
		Delete
	</button>
</mat-dialog-actions>
